export const USER_INFO = 'USER_INFO'
export const CONTENT_TYPE = 'CONTENT_TYPE'
export const DEL_TIME_LINE = 'DEL_TIME_LINE'
export const ADD_TIME_LINE = 'ADD_TIME_LINE'
export const ADD_TIME_VALUE = 'ADD_TIME_VALUE'
export const DEL_TIME_VALUE = 'DEL_TIME_VALUE'
export const MODIFY_TIME_VALUE = 'MODIFY_TIME_VALUE'
export const MODIFY_TIME_SCALE = 'MODIFY_TIME_SCALE'
export const MODIFY_TIME_ITEM = 'MODIFY_TIME_ITEM'
export const SET_CATE_LIST = 'SET_CATE_LIST'
export const SET_CURRENT_DRAGITEM = 'SET_CURRENT_DRAGITEM'
export const ADD_CURRENT_VIDEOINFO = 'ADD_CURRENT_VIDEOINFO'
export const MODIFY_CURRENT_TIME = 'MODIFY_CURRENT_TIME'
export const DEL_DRAG_ITEM = 'DEL_DRAG_ITEM'
export const CLEAR_TIME_LINE = 'CLEAR_TIME_LINE'
export const ADD_FIELDS_VALUE = 'ADD_FIELDS_VALUE'
export const ADD_FIELDS_VALUE_SINGLE = 'ADD_FIELDS_VALUE_SINGLE'
export const SAVE_CANVAS_INFO = 'SAVE_CANVAS_INFO'
export const SET_CANVAS_PLAYING = 'SET_CANVAS_PLAYING'
export const SET_CONVERT_ING = 'SET_CONVERT_ING'
export const ADD_TRANSITION_DATA = 'ADD_TRANSITION_DATA'
export const MOD_CREATE_VIDEO= 'MOD_CREATE_VIDEO'
export const MOD_VERSION_LIST= 'MOD_VERSION_LIST'
export const ADD_VERSION_LIST= 'ADD_VERSION_LIST'
export const ADD_QUICK_CREATE = 'ADD_QUICK_CREATE'
export const DEL_SUBTITLE = 'DEL_SUBTITLE'
export const MODIFY_SUBTITLE = 'MODIFY_SUBTITLE'
export const DEL_SUBTITLE_LINE = 'DEL_SUBTITLE_LINE'
export const ADD_CONPANY = 'ADD_CONPANY'
export const DEL_CONPANY = 'DEL_CONPANY'
export const ADD_CONPANY_LIST = 'ADD_CONPANY_LIST'
export const SET_CURRENT_LOGIN = 'SET_CURRENT_LOGIN'
export const WORK_INFO = 'WORK_INFO'